/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { responsesPartMeta } from '../models/responsesPartMeta';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class BrandsProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * get a company default brand
   * @returns any status success
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesBrandsDefault(): CancelablePromise<{
    data?: {
      readonly uuid?: string;
      readonly createdAt?: string;
      readonly createdBy?: string;
      readonly lastUpdatedAt?: string;
      readonly lastUpdatedBy?: string;
      readonly lastUpdatedByAudience?: string;
      readonly lastUpdatedByAudienceUuid?: string;
      readonly lastUpdatedByImpersonatedBy?: string;
      readonly lastUpdatedByCompanyUuid?: string;
      readonly lastUpdatedByEnterpriseUuid?: string;
      name: string;
      companyUuid?: string;
      logoUrl?: string;
      websiteUrl?: string;
      colors?: {
        primary?: string;
        secondary?: string;
      };
      welcomeContent?: {
        message?: string;
      };
      helpContent?: {
        message?: string;
      };
      onboardingContent?: {
        message?: string;
      };
      invitationMessage?: {
        invitationEmailEnabled?: boolean;
        invitationSmsEnabled?: boolean;
        email?: {
          subject: string;
          content: string;
        };
        sms?: {
          content: string;
        };
      };
      emailTemplateUuid?: string | null;
      hireBrandId?: string;
      /**
       * The system that last updated this brand (hire or wx)
       */
      originSystem?: string;
      /**
       * When the brand was last updated in the origin system
       */
      originUpdatedAt?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/brands/default',
    });
  }

  /**
   * import the brands from Hire
   * @returns any status success
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesBrandsImportFromHire(): CancelablePromise<{
    data?: {
      count?: number;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/brands/importFromHire',
    });
  }

  /**
   * Return non-sensitive data about a brand
   * @param brandUuid brand uuid
   * @returns any Return non-sensitive data about a brand
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesBrandsFiltered(
    brandUuid: string,
  ): CancelablePromise<{
    data?: {
      readonly uuid?: string;
      logoUrl?: string;
      websiteUrl?: string;
      colors?: {
        primary?: string;
        secondary?: string;
      };
      companyUuid?: string;
    };
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/brands/{brandUuid}/filtered',
      path: {
        'brandUuid': brandUuid,
      },
    });
  }

  /**
   * Create one or multiple new brands
   * @param requestBody
   * @returns any Successfully created brand(s)
   * @throws ApiError
   */
  public postApiServiceorganizationsProcessesBrands(
    requestBody: {
      /**
       * Brand name
       */
      name: string;
      /**
       * URL to the brand logo
       */
      logoUrl?: string;
      /**
       * Brand website URL
       */
      websiteUrl?: string;
      /**
       * Brand colors
       */
      colors?: {
        /**
         * Primary brand color (hex)
         */
        primary?: string;
        /**
         * Secondary brand color (hex)
         */
        secondary?: string;
      };
      /**
       * Welcome message content
       */
      welcomeContent?: {
        /**
         * Message content
         */
        message?: string;
      };
      /**
       * Help message content
       */
      helpContent?: {
        /**
         * Message content
         */
        message?: string;
      };
      /**
       * Onboarding message content
       */
      onboardingContent?: {
        /**
         * Message content
         */
        message?: string;
      };
      /**
       * Invitation message settings
       */
      invitationMessage?: {
        /**
         * Whether invitation emails are enabled
         */
        invitationEmailEnabled?: boolean;
        /**
         * Whether invitation SMS are enabled
         */
        invitationSmsEnabled?: boolean;
        /**
         * Email invitation settings
         */
        email?: {
          subject?: string;
          content?: string;
        };
        /**
         * SMS invitation settings
         */
        sms?: {
          content?: string;
        };
      };
      /**
       * Email template UUID
       */
      emailTemplateUuid?: string | null;
      /**
       * Hire brand ID (external reference)
       */
      hireBrandId?: string;
    },
  ): CancelablePromise<{
    readonly uuid?: string;
    readonly createdAt?: string;
    readonly createdBy?: string;
    readonly lastUpdatedAt?: string;
    readonly lastUpdatedBy?: string;
    readonly lastUpdatedByAudience?: string;
    readonly lastUpdatedByAudienceUuid?: string;
    readonly lastUpdatedByImpersonatedBy?: string;
    readonly lastUpdatedByCompanyUuid?: string;
    readonly lastUpdatedByEnterpriseUuid?: string;
    name: string;
    companyUuid?: string;
    logoUrl?: string;
    websiteUrl?: string;
    colors?: {
      primary?: string;
      secondary?: string;
    };
    welcomeContent?: {
      message?: string;
    };
    helpContent?: {
      message?: string;
    };
    onboardingContent?: {
      message?: string;
    };
    invitationMessage?: {
      invitationEmailEnabled?: boolean;
      invitationSmsEnabled?: boolean;
      email?: {
        subject: string;
        content: string;
      };
      sms?: {
        content: string;
      };
    };
    emailTemplateUuid?: string | null;
    hireBrandId?: string;
    /**
     * The system that last updated this brand (hire or wx)
     */
    originSystem?: string;
    /**
     * When the brand was last updated in the origin system
     */
    originUpdatedAt?: string;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/processes/brands',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `default error response`,
        500: `default error response`,
      },
    });
  }

  /**
   * Update one or multiple existing brands
   * @param requestBody
   * @returns any Successfully updated brand(s)
   * @throws ApiError
   */
  public patchApiServiceorganizationsProcessesBrands(
    requestBody: {
      /**
       * Brand name
       */
      name?: string;
      /**
       * URL to the brand logo
       */
      logoUrl?: string;
      /**
       * Brand website URL
       */
      websiteUrl?: string;
      /**
       * Brand colors
       */
      colors?: {
        /**
         * Primary brand color (hex)
         */
        primary?: string;
        /**
         * Secondary brand color (hex)
         */
        secondary?: string;
      };
      /**
       * Welcome message content
       */
      welcomeContent?: {
        /**
         * Message content
         */
        message?: string;
      };
      /**
       * Help message content
       */
      helpContent?: {
        /**
         * Message content
         */
        message?: string;
      };
      /**
       * Onboarding message content
       */
      onboardingContent?: {
        /**
         * Message content
         */
        message?: string;
      };
      /**
       * Invitation message settings
       */
      invitationMessage?: {
        /**
         * Whether invitation emails are enabled
         */
        invitationEmailEnabled?: boolean;
        /**
         * Whether invitation SMS are enabled
         */
        invitationSmsEnabled?: boolean;
        /**
         * Email invitation settings
         */
        email?: {
          subject?: string;
          content?: string;
        };
        /**
         * SMS invitation settings
         */
        sms?: {
          content?: string;
        };
      };
      /**
       * Email template UUID
       */
      emailTemplateUuid?: string | null;
      /**
       * Hire brand ID (external reference)
       */
      hireBrandId?: string;
      /**
       * Unique identifier for the brand.
       */
      uuid: string;
    },
  ): CancelablePromise<{
    readonly uuid?: string;
    readonly createdAt?: string;
    readonly createdBy?: string;
    readonly lastUpdatedAt?: string;
    readonly lastUpdatedBy?: string;
    readonly lastUpdatedByAudience?: string;
    readonly lastUpdatedByAudienceUuid?: string;
    readonly lastUpdatedByImpersonatedBy?: string;
    readonly lastUpdatedByCompanyUuid?: string;
    readonly lastUpdatedByEnterpriseUuid?: string;
    name: string;
    companyUuid?: string;
    logoUrl?: string;
    websiteUrl?: string;
    colors?: {
      primary?: string;
      secondary?: string;
    };
    welcomeContent?: {
      message?: string;
    };
    helpContent?: {
      message?: string;
    };
    onboardingContent?: {
      message?: string;
    };
    invitationMessage?: {
      invitationEmailEnabled?: boolean;
      invitationSmsEnabled?: boolean;
      email?: {
        subject: string;
        content: string;
      };
      sms?: {
        content: string;
      };
    };
    emailTemplateUuid?: string | null;
    hireBrandId?: string;
    /**
     * The system that last updated this brand (hire or wx)
     */
    originSystem?: string;
    /**
     * When the brand was last updated in the origin system
     */
    originUpdatedAt?: string;
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/serviceorganizations/processes/brands',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `default error response`,
        500: `default error response`,
      },
    });
  }

}
